import React from 'react';
import { ScrollReveal } from './ScrollReveal';
export function ValueSection() {
  const benefits = [{
    title: 'Stable Revenue Without the Strain',
    description: 'Your income becomes predictable because your energy becomes regulated. No more swinging between overextension and collapse. You create consistent results from a place of coherence, not chaos.'
  }, {
    title: 'Clear Decisions in Minutes, Not Days',
    description: 'Decision fatigue disappears when you operate from a grounded nervous system. You access your intuition instantly and make powerful choices without second-guessing or spiraling into analysis paralysis.'
  }, {
    title: 'A Business That Supports Your Life',
    description: 'Your company becomes a vehicle for freedom, not a cage. You build operational structures that work without your constant presence, giving you the space to travel, invest, or simply be present with the people you love.'
  }, {
    title: 'Leadership That Feels Like Power, Not Pressure',
    description: 'You step into visibility and authority without fragmenting. Your team trusts your direction. Your clients feel your alignment. You lead from a place of deep knowing instead of reactive scrambling.'
  }];
  return <section className="py-28 px-6 bg-cream-light relative" data-id="element-148">
      <div className="max-w-6xl mx-auto" data-id="element-149">
        <ScrollReveal width="100%" className="mb-20 text-center" data-id="element-150">
          <span className="text-xs font-sans font-medium tracking-editorial text-slate uppercase border-b border-slate/20 pb-2 inline-block" data-id="element-151">
            The Transformation
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-ink mt-8 leading-tight" data-id="element-152">
            What You Gain When You Stop Fighting Your Own Business
          </h2>
        </ScrollReveal>

        <div className="space-y-0" data-id="element-153">
          {benefits.map((benefit, index) => <div key={index} className="relative" data-id="element-154">
              <ScrollReveal delay={index * 0.1} data-id="element-155">
                <div className={`flex flex-col md:flex-row items-baseline py-12 ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse text-right md:text-left'}`} data-id="element-156">
                  {/* Number */}
                  <div className={`w-full md:w-1/4 mb-4 md:mb-0 ${index % 2 === 0 ? 'md:text-right md:pr-12' : 'md:text-left md:pl-12'}`} data-id="element-157">
                    <span className="font-serif text-5xl md:text-6xl text-slate/15" data-id="element-158">
                      0{index + 1}
                    </span>
                  </div>

                  {/* Content */}
                  <div className={`w-full md:w-3/4 ${index % 2 !== 0 && 'md:text-right'}`} data-id="element-159">
                    <h3 className="font-serif text-2xl md:text-3xl text-ink mb-3" data-id="element-160">
                      {benefit.title}
                    </h3>
                    <p className="font-sans text-slate text-base md:text-lg leading-relaxed max-w-xl font-light" data-id="element-161">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </ScrollReveal>

              {/* Divider Line */}
              {index !== benefits.length - 1 && <div className="absolute bottom-0 left-0 w-full h-px bg-slate/10" data-id="element-162" />}
            </div>)}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full h-px bg-ink/10" data-id="element-163" />
    </section>;
}